// src/lib/sanitize.js

export const clampLen = (s, n) => String(s ?? '').slice(0, n);

export const stripControls = (s) => {
  const input = String(s ?? '');
  let out = '';

  for (let i = 0; i < input.length; i++) {
    const ch = input[i];
    const code = ch.charCodeAt(0);
    // оставляем:
    //  - печатные ASCII (код >= 0x20 и не DEL)
    //  - всё, что > 0x9F (выше control-диапазона)
    if (
      (code >= 0x20 && code !== 0x7f) || // печатные ASCII
      code > 0x9f                         // вне C1 control range
    ) {
      out += ch;
    }
  }

  return out;
};

// Email normalization
export const sanitizeEmail = (s) =>
  clampLen(stripControls(String(s ?? '').trim().toLowerCase()), 254);

// Password normalization (no aggressive trimming, NFC/NFKC against spoofing)
export const sanitizePassword = (s) =>
  clampLen(String(s ?? '').normalize('NFKC'), 512);

// Text without HTML/inline handlers; escaped < >
export const sanitizeText = (val, maxLen = 5000) => {
  const s = String(val ?? '')
    .replace(/<\s*\/?\s*(script|style|iframe|object|embed)[^>]*>/gi, '')
    .replace(/\son[a-z]+\s*=\s*(['"]).*?\1/gi, '') // onload=...
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .trim();
  return clampLen(s, maxLen);
};

// URL is http/https only; no data:/javascript:, quotes, or < >
export const sanitizeURL = (url, allowEmpty = true) => {
  const raw = String(url ?? '').trim();
  if (!raw) return allowEmpty ? '' : null;
  if (/[<>"'`]/.test(raw)) return null;
  try {
    const u = new URL(raw);
    if (!/^https?:$/.test(u.protocol)) return null;
    return u.toString();
  } catch {
    return null;
  }
};

export const isSafeImageURL = (url) => {
  const u = sanitizeURL(url, false);
  if (!u) return false;
  if (/\.svg(\?.*)?$/i.test(u)) return false;
  return /\.(png|jpe?g|gif|webp|bmp)(\?.*)?$/i.test(u);
};

export const extFromMime = (mime) => {
  if (mime === 'image/png') return '.png';
  if (mime === 'image/jpeg') return '.jpg';
  if (mime === 'image/gif') return '.gif';
  if (mime === 'image/webp') return '.webp';
  if (mime === 'image/bmp') return '.bmp';
  return '';
};
